export default __webpack_public_path__ + "static/media/quiz.f291e681.jpg";